import React from "react";
import {
  DayRange,
  InternalOpsPage,
  InternalOpsState,
  StatCard,
  UsageChart,
  useDayRange,
  useInternalOpsFetch,
  withQuery,
} from "./internalOpsUi";
import { API_ENDPOINTS } from "../../config/apiConfig";

const TRAFFIC_SERIES = [
  { key: "hits", name: "Homepage loads", stroke: "#0f172a", fill: "#e2e8f0" },
  { key: "uniques", name: "Unique visitors", stroke: "#2563eb", fill: "#dbeafe" },
];

export default function InternalOpsTraffic() {
  const [days, setDays] = useDayRange();
  const { data, loading, error } = useInternalOpsFetch(
    withQuery(API_ENDPOINTS.internalOpsTraffic, { days })
  );

  return (
    <InternalOpsPage
      title="Site traffic"
      subtitle="First-party homepage loads vs Google Analytics consented sessions."
    >
      <div className="mb-6 flex justify-end">
        <DayRange days={days} onChange={setDays} />
      </div>
      <InternalOpsState loading={loading} error={error}>
        {data ? (
          <div className="space-y-6">
            <UsageChart
              rows={data.homepage_by_day}
              title="Homepage traffic"
              caption={`Daily loads over the last ${data.days} days, UTC.`}
              series={TRAFFIC_SERIES}
              empty="No homepage loads recorded yet."
            />
            <div className="grid gap-4 sm:grid-cols-3">
              <StatCard label="Homepage loads" value={data.homepage_hits} />
              <StatCard label="Approx. unique / day hashes" value={data.homepage_uniques} />
              <StatCard label="All tracked marketing paths" value={data.all_tracked_hits} />
            </div>
          </div>
        ) : null}
      </InternalOpsState>
    </InternalOpsPage>
  );
}
